import type { GridInterface } from '@ad-lucy/context/adData';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid2x3 = (): GridInterface[] =>
  defineGrid('2:3', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 3,
              spanCol: 2,
            },
          ],
        },
      ],
    },
    {
      name: BREAKPOINT_DISPLAY_NAME.HPA,
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 3,
            },
          ],
        },
      ],
    },
    {
      name: BREAKPOINT_DISPLAY_NAME.MOBILE,
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
            },
          ],
        },
      ],
    },
  ]);
